<template>
  <d2-container>
    <div class="webTemplateEdit">
      <!-- 基础信息 -->
      <el-form :model="form" label-width="100px" size="small" class="base-form">
        <el-form-item label="模板名称：" required>
          <el-input
            v-model="form.name"
            style="width: 320px"
            placeholder="请输入名称（最多20字）"
            maxlength="20"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="设为首页：">
          <el-radio-group v-model="form.isHome">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动规则：">
          <el-radio-group v-model="form.ruleType" @change="onRuleTypeChange">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">有</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="form.ruleType === 1">
          <el-form-item label="展示方式：">
            <el-radio-group v-model="form.showWay" @change="onShowWayChange">
              <el-radio :label="0">文字</el-radio>
              <el-radio :label="1">图片弹窗</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label=" " v-if="form.showWay === 1">
            <uploadImg
              v-model="form.ruleDetail"
              :imgSize="1"
              :text="['图片大小1MB以内', '图片格式png/jpg', '图片尺寸750']"
            ></uploadImg>
          </el-form-item>
          <el-form-item label=" " v-if="form.showWay === 0">
            <div class="ql-editor-wrap">
              <quill-editor
                ref="myQuillEditor"
                v-model="form.ruleDetail"
                :options="editorOption"
                @ready="onEditorReady"
              />
            </div>
          </el-form-item>
        </template>
      </el-form>

      <!-- 装修编辑器：三栏布局 -->
      <div class="editor-layout">
        <!-- 左侧：模块面板 -->
        <div class="module-palette">
          <div class="palette-header">
            <i class="el-icon-s-grid"></i> 装修模块
          </div>
          <div class="palette-hint">拖拽到右侧预览区</div>
          <draggable
            v-model="templateArray"
            :options="tplOptions"
            :move="onMove"
            class="palette-list"
          >
            <div
              v-for="item in templateArray"
              :key="item.type"
              class="palette-item"
            >
              <i :class="getModuleIcon(item.type)" class="palette-icon"></i>
              <span class="palette-name">{{ item.name }}</span>
              <i class="el-icon-rank drag-handle"></i>
            </div>
          </draggable>
        </div>

        <!-- 中间：预览画布 -->
        <div class="preview-wrap">
          <div class="preview-header">
            <span class="preview-title">页面预览</span>
            <div class="preview-controls">
              <span class="color-label">背景色</span>
              <el-color-picker
                v-model="form.backgroundColour"
                size="mini"
              ></el-color-picker>
              <el-button
                size="mini"
                @click="reset"
                style="margin-left:8px"
              >重置</el-button>
            </div>
          </div>
          <div class="preview-phone" :style="{ background: form.backgroundColour }">
            <draggable
              v-model="floorList"
              :options="floorOptions"
              style="min-height: 100%"
              @add="addFloorList"
              @end="endFloorList"
            >
              <div
                v-for="(item, index) in floorList"
                :key="index"
                class="floor-item"
                :class="{ 'floor-item--active': activeIndex === index }"
                @click="selectModule(item, index)"
              >
                <!-- 模块预览内容 -->
                <div v-if="item.dataJson">
                  <!-- 轮播模块 -->
                  <div v-if="item.type === 8" class="preview-block">
                    <el-carousel height="180px" :autoplay="false">
                      <el-carousel-item
                        v-for="(ci, ci_idx) in item.dataJson.dataList"
                        :key="ci_idx"
                      >
                        <img :src="ci.imgSrc && ci.imgSrc[0]" style="width:100%;height:180px;object-fit:cover" />
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <!-- 图片/分类模块 -->
                  <div v-if="item.type === 3" class="preview-block flex-block">
                    <div
                      v-for="(img, img_idx) in item.dataJson.dataList"
                      :key="img_idx"
                      :style="{ width: 100 / item.dataJson.dataList.length + '%' }"
                    >
                      <img :src="img.imgSrc && img.imgSrc[0]" style="width:100%;height:auto" />
                    </div>
                  </div>
                  <!-- 绑定模块 -->
                  <div v-if="item.type === 2" class="preview-block binding-preview">
                    <div class="bp-title">{{ item.dataJson.titleName }}</div>
                    <div class="bp-content">{{ item.dataJson.contentName }}</div>
                    <div class="bp-btn">{{ item.dataJson.buttonName }}</div>
                  </div>
                  <!-- 优惠模块 -->
                  <div v-if="item.type === 4" class="preview-block placeholder-block">
                    <img src="https://cdn.xiaolouyou.com/o_1fhs5chmh1qva3ht12ia1nctirc.jpg" style="width:100%" />
                  </div>
                  <!-- 分类图标 -->
                  <div v-if="item.type === 5" class="preview-block flex-block flex-wrap">
                    <div
                      v-for="(img, img_idx) in item.dataJson.dataList"
                      :key="img_idx"
                      style="width:25%"
                    >
                      <img :src="img.imgSrc && img.imgSrc[0]" style="width:100%;height:auto" />
                    </div>
                  </div>
                  <!-- 专题轮播 -->
                  <div v-if="item.type === 1" class="preview-block">
                    <el-carousel height="130px" :autoplay="false">
                      <el-carousel-item
                        v-for="(ci, ci_idx) in item.dataJson.dataList"
                        :key="ci_idx"
                      >
                        <img :src="ci.imgSrc && ci.imgSrc[0]" style="width:100%;height:130px;object-fit:cover" />
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <!-- 分类商品 -->
                  <div v-if="item.type === 6" class="preview-block placeholder-block">
                    <img src="https://cdn.xiaolouyou.com/o_1fih18a3t1uqk19jq1u7913rm141jc.jpg" style="width:100%" />
                  </div>
                  <!-- 商品模块 -->
                  <div v-if="item.type === 7" class="preview-block placeholder-block">
                    <img src="https://cdn.xiaolouyou.com/o_1fih971he1h9126vi7e16eci8n7.jpg" style="width:100%" />
                  </div>
                  <!-- 视频模块 -->
                  <div v-if="item.type === 10" class="preview-block">
                    <video
                      v-if="item.dataJson.dataList && item.dataJson.dataList[0] && item.dataJson.dataList[0].videoSrc && item.dataJson.dataList[0].videoSrc[0]"
                      controls
                      style="width:100%"
                      :src="item.dataJson.dataList[0].videoSrc[0]"
                    ></video>
                    <img
                      v-else
                      src="https://oss.lifeinmark.com/330bd51ff6f2e649d6c1d24884ebac4.jpg"
                      style="width:100%"
                    />
                  </div>
                </div>
                <div v-else class="floor-placeholder">
                  <i :class="getModuleIcon(item.type)"></i>
                  <span>{{ item.name }}</span>
                  <span class="floor-hint">点击右上角编辑按钮配置</span>
                </div>

                <!-- 操作按钮 -->
                <div class="floor-ops">
                  <el-tooltip content="编辑" placement="left">
                    <el-button
                      type="primary"
                      size="mini"
                      circle
                      icon="el-icon-edit"
                      @click.stop="selectModule(item, index)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip content="删除" placement="left">
                    <el-button
                      type="danger"
                      size="mini"
                      circle
                      icon="el-icon-delete"
                      @click.stop="deleteFloor(index)"
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </draggable>
            <div v-if="floorList.length === 0" class="drop-hint">
              <i class="el-icon-bottom drop-hint-icon"></i>
              <p>从左侧拖拽模块到此处</p>
            </div>
          </div>
        </div>

        <!-- 右侧：属性面板 -->
        <div class="panel-col">
          <PropertyPanel
            :module="activeItem"
            :module-index="activeIndex"
            @save="onPanelSave"
            @close="clearActive"
          ></PropertyPanel>
        </div>
      </div>

      <!-- 底部操作 -->
      <div class="form-actions">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="goBack">返回</el-button>
      </div>
    </div>
  </d2-container>
</template>

<script>
import draggable from 'vuedraggable'
import PropertyPanel from '../templateDialog/PropertyPanel.vue'
import uploadImg from '@/components/uploadImage/index.vue'
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
import { getAdd, getinfo, getUpdate } from '@/api/demo/webTemplateEdit/index'
import { getToken } from '@/api/demo/classification/index'

const titleConfig = [
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-clean', title: '清除格式' }
]

const MODULE_ICONS = {
  1: 'el-icon-picture-outline',
  2: 'el-icon-connection',
  3: 'el-icon-menu',
  4: 'el-icon-discount',
  5: 'el-icon-s-flag',
  6: 'el-icon-s-shop',
  7: 'el-icon-goods',
  8: 'el-icon-film',
  10: 'el-icon-video-camera'
}

Quill.register('modules/ImageExtend', ImageExtend)

export default {
  name: 'webTemplateEdit',
  components: {
    draggable,
    PropertyPanel,
    uploadImg,
    quillEditor
  },
  data () {
    return {
      form: {
        name: '',
        backgroundColour: '#FFFFFF',
        isHome: 0,
        ruleType: 0,
        modules: [],
        ruleDetail: '',
        showWay: ''
      },
      templateArray: [
        { name: '轮播模块', type: 8, sort: '', dataJson: '' },
        { name: '专题轮播', type: 1, sort: '', dataJson: '' },
        { name: '视频模块', type: 10, sort: '', dataJson: '' },
        { name: '商品模块', type: 7, sort: '', dataJson: '' },
        { name: '绑定模块', type: 2, sort: '', dataJson: '' },
        { name: '分类模块', type: 3, sort: '', dataJson: '' },
        { name: '优惠模块', type: 4, sort: '', dataJson: '', remodelAssemblyGoodsAddVOList: [], remodelAssemblycouponList: [] },
        { name: '图标', type: 5, sort: '', dataJson: '' },
        { name: '分类商品', type: 6, sort: '', dataJson: '' }
      ],
      editorOption: {
        modules: {
          ImageExtend: {
            loading: true,
            name: 'file',
            action: 'https://up-z2.qiniup.com',
            response: res => this.https + '/' + res.key,
            change: (xhr, formData) => {
              formData.append('token', this.uploadData.token)
              formData.append('key', `upload_pic_${new Date().getTime()}`)
            }
          },
          toolbar: {
            container: container,
            handlers: {
              image: function () { QuillWatch.emit(this.quill.id) }
            }
          }
        }
      },
      uploadData: { key: '', token: '' },
      https: null,
      tplOptions: {
        group: { name: 'tplGroup', pull: 'clone', put: false },
        sort: false
      },
      floorList: [],
      floorOptions: {
        animation: 200,
        group: { name: 'tplGroup', put: true },
        sort: true
      },
      activeItem: null,
      activeIndex: -1,
      edId: null
    }
  },
  watch: {
    $route () {
      this.loadDetail()
    }
  },
  created () {
    if (this.$route.query.id) {
      this.edId = this.$route.query.id
      this.loadDetail(this.$route.query.id)
    }
  },
  methods: {
    getModuleIcon (type) {
      return MODULE_ICONS[type] || 'el-icon-s-grid'
    },
    selectModule (item, index) {
      this.activeItem = item
      this.activeIndex = index
      // 预取 token（图片上传用）
      getToken({}).then(res => {
        this.uploadData.token = res.token
        this.https = res.domain
      })
    },
    clearActive () {
      this.activeItem = null
      this.activeIndex = -1
    },
    onPanelSave (updatedItem) {
      // 检查模块名称不重复
      for (let i = 0; i < this.floorList.length; i++) {
        if (this.floorList[i].name === updatedItem.name && i !== this.activeIndex) {
          this.$message.error('模块名称不能重复')
          return
        }
      }
      this.$set(this.floorList, this.activeIndex, updatedItem)
      this.activeItem = updatedItem
      this.$message.success('保存成功')
    },
    deleteFloor (index) {
      // 清除关联
      this.floorList.forEach(v => {
        if (v.type === 8 && v.dataJson) {
          v.dataJson.dataList && v.dataJson.dataList.forEach(i => {
            if (i.correlation === this.floorList[index].name) {
              i.correlation = ''
            }
          })
        }
      })
      this.floorList.splice(index, 1)
      if (this.activeIndex === index) {
        this.clearActive()
      } else if (this.activeIndex > index) {
        this.activeIndex--
      }
    },
    onMove (e) {
      for (const floor of this.floorList) {
        if (floor.type === 8 && e.draggedContext.element.type === 8) {
          return false
        }
      }
      return true
    },
    endFloorList () {},
    addFloorList (e) {
      this.templateArray = JSON.parse(JSON.stringify(this.templateArray))
      let repetitionNum = 0
      this.floorList.forEach(v => {
        if (this.floorList[e.newIndex].type === v.type) repetitionNum++
      })
      this.floorList[e.newIndex].name += repetitionNum || ''
    },
    reset () {
      if (this.edId) {
        this.loadDetail(this.edId, 'reset')
      } else {
        this.floorList = []
        Object.assign(this.$data.form, this.$options.data().form)
      }
      this.clearActive()
    },
    save () {
      if (!this.form.name) {
        this.$message.error('请输入模板名称')
        return
      }
      const params = JSON.parse(JSON.stringify(this.form))
      delete params.remodelAssemblyDetailsVOList
      params.modules = JSON.parse(JSON.stringify(this.floorList))
      params.modules.forEach((v, index) => {
        v.dataJson = JSON.stringify(v.dataJson)
        v.sort = index + 1
      })

      if (this.form.showWay === 0 && this.form.ruleDetail) {
        params.ruleDetail = this.form.ruleDetail.replace(
          /(<img|<p|<blockquote|undefined|<br>|re |<\/pre>|<li|<a href|><\/a>)/gi,
          ($0, $1) => ({
            're ': '><pre ',
            '</pre>': '</pre>',
            '<p': '<p style="line-height:30px;"',
            '<img': '<img style="max-width:100%;height:auto;margin:5px 0;"',
            '<li': '<li style="line-height:30px"',
            '<blockquote': '<blockquote style="border-left:4px solid #ccc;margin-bottom:5px;padding-left:16px;"',
            undefined: '',
            '<br>': '<br>',
            '<a href': '<a style="color:blue;cursor:pointer;" href',
            '></a>': '/></a>'
          })[$1]
        )
      }

      const action = this.edId
        ? getUpdate(this.edId, params)
        : getAdd(params)

      action.then(() => {
        this.$notify({ title: '成功', message: this.edId ? '编辑成功' : '新建成功', type: 'success', duration: 2000 })
        this.$router.back()
      })
    },
    goBack () {
      this.$router.back()
    },
    loadDetail (id, type) {
      getinfo(id || this.edId).then(res => {
        if (!type) this.form = res
        this.floorList = res.modules.map(v => {
          v.dataJson = JSON.parse(v.dataJson)
          return v
        })
      })
    },
    onRuleTypeChange () {
      this.form.showWay = this.form.ruleType ? 0 : ''
      this.form.ruleDetail = ''
    },
    onShowWayChange (val) {
      this.form.showWay = val
      if (val === 0) {
        this.$nextTick(() => this.initEditorTitle())
      }
    },
    initEditorTitle () {
      const el = document.getElementsByClassName('ql-editor')[0]
      if (el) el.dataset.placeholder = ''
      for (const item of titleConfig) {
        const tip = document.querySelector('.quill-editor ' + item.Choice)
        if (tip) tip.setAttribute('title', item.title)
      }
    },
    onEditorReady () {
      this.initEditorTitle()
    }
  }
}
</script>

<style lang="scss" scoped>
.webTemplateEdit {
  padding: 0 0 20px;

  // 基础信息表单
  .base-form {
    padding: 20px 20px 0;
    margin-bottom: 0;
  }

  .ql-editor-wrap {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    max-width: 700px;
  }

  // 三栏编辑器布局
  .editor-layout {
    display: flex;
    align-items: flex-start;
    gap: 0;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    margin: 16px 20px;
    background: #f5f7fa;
    overflow: hidden;
  }

  // 左侧模块面板
  .module-palette {
    width: 180px;
    flex-shrink: 0;
    background: #fff;
    border-right: 1px solid #e8e8e8;
    display: flex;
    flex-direction: column;

    .palette-header {
      padding: 12px 16px;
      font-size: 13px;
      font-weight: 600;
      color: #303133;
      background: #f0f2f5;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .palette-hint {
      font-size: 11px;
      color: #c0c4cc;
      padding: 6px 16px;
      background: #fafafa;
      border-bottom: 1px solid #f0f0f0;
    }

    .palette-list {
      padding: 8px;
      flex: 1;
    }

    .palette-item {
      display: flex;
      align-items: center;
      padding: 8px 10px;
      border: 1px solid #e8e8e8;
      border-radius: 6px;
      margin-bottom: 6px;
      background: #fff;
      cursor: grab;
      font-size: 12px;
      color: #606266;
      transition: all 0.2s;

      &:hover {
        border-color: #409eff;
        color: #409eff;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
      }

      &:active {
        cursor: grabbing;
      }

      .palette-icon {
        font-size: 16px;
        margin-right: 6px;
        color: #909399;
      }

      .palette-name {
        flex: 1;
        font-size: 12px;
      }

      .drag-handle {
        color: #c0c4cc;
        font-size: 14px;
      }
    }
  }

  // 中间预览区
  .preview-wrap {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-right: 1px solid #e8e8e8;

    .preview-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px;
      background: #f0f2f5;
      border-bottom: 1px solid #e8e8e8;

      .preview-title {
        font-size: 13px;
        font-weight: 600;
        color: #303133;
      }

      .preview-controls {
        display: flex;
        align-items: center;
        gap: 6px;

        .color-label {
          font-size: 12px;
          color: #606266;
        }
      }
    }

    .preview-phone {
      width: 375px;
      min-height: 667px;
      margin: 16px auto;
      border: 1px solid #dcdfe6;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      position: relative;

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background: #ddd;
      }
    }

    .drop-hint {
      text-align: center;
      padding: 60px 20px;
      color: #c0c4cc;
      font-size: 13px;

      .drop-hint-icon {
        font-size: 32px;
        display: block;
        margin-bottom: 12px;
      }
    }
  }

  // 楼层条目
  .floor-item {
    position: relative;
    cursor: pointer;
    border: 2px solid transparent;
    transition: border-color 0.2s;

    &:hover {
      border-color: #409eff;

      .floor-ops {
        opacity: 1;
      }
    }

    &--active {
      border-color: #409eff;

      .floor-ops {
        opacity: 1;
      }
    }

    .preview-block {
      width: 100%;
    }

    .flex-block {
      display: flex;
    }

    .flex-wrap {
      flex-wrap: wrap;
    }

    .placeholder-block {
      img {
        width: 100%;
        display: block;
      }
    }

    .binding-preview {
      padding: 20px;
      text-align: center;

      .bp-title {
        font-size: 18px;
        font-weight: bold;
        color: #05413e;
      }

      .bp-content {
        font-size: 14px;
        color: #05413e;
        margin: 10px 0;
      }

      .bp-btn {
        display: inline-block;
        padding: 10px 40px;
        background: #004643;
        color: #fff;
        border-radius: 24px;
        font-size: 14px;
        margin-top: 6px;
      }
    }

    .floor-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 80px;
      background: #f5f7fa;
      color: #909399;
      font-size: 13px;
      gap: 4px;

      i {
        font-size: 24px;
        margin-bottom: 4px;
      }

      .floor-hint {
        font-size: 11px;
        color: #c0c4cc;
      }
    }

    // 操作按钮
    .floor-ops {
      position: absolute;
      top: 6px;
      right: 6px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      opacity: 0;
      transition: opacity 0.2s;
      z-index: 10;
    }
  }

  // 右侧属性面板列
  .panel-col {
    width: 320px;
    flex-shrink: 0;
    height: 699px; // preview-phone height + header + margin
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  // 底部操作栏
  .form-actions {
    text-align: center;
    padding: 0 20px 10px;
    display: flex;
    justify-content: center;
    gap: 12px;
  }
}
</style>
